<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Recibos</h4>
            <div class="small text-muted">Administración de todos los recibos</div>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
          <b-row>            
            <b-col lg="8">
              <b-row>    
                <b-col lg="6">
                  <Widget :configWidget="configWidget" reference="indicator_total_amount_receipts_today" :hasAccess="configWidget.elements.indicatorTotalAmountReceiptsToday" />
                </b-col>            
                <b-col lg="6">                        
                  <Widget :configWidget="configWidget" reference="indicator_total_receipts_today" :hasAccess="configWidget.elements.indicatorTotalReceiptsToday" />
                </b-col>
                <b-col lg="12">                        
                  <Widget :configWidget="configWidget" reference="bar_receipts_months" :hasAccess="configWidget.elements.barReceiptsMonths" />
                </b-col>  
              </b-row>
            </b-col>
            <b-col lg="4">
              <Widget :configWidget="configWidget" reference="list_balance_positive_current_account" :hasAccess="configWidget.elements.listBalancePositiveCurrentAccount" />              
              <Widget :configWidget="configWidget" reference="list_balance_negative_current_account" :hasAccess="configWidget.elements.listBalanceNegativeCurrentAccount" />                            
            </b-col>
          </b-row>
        </b-col>  
        <b-col lg="3">
          
          <b-list-group class="mb-1" v-if="parameters.allowReceiptsTrashed">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openReceiptsTrashed()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Recibos Provisorios</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Generación de recibos sin aprobación
              </p>
            </b-list-group-item>
          </b-list-group>     
          <b-list-group>
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openReceipts()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Recibos</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de todos los recibos ingresados al sistema
              </p>
            </b-list-group-item>            
          </b-list-group>                        

        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  //import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import Param from '@/config/parameters'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.RECIBOS_ERP,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.RECIBOS_ERP,
          profile_id: Profiles.PERSONAL,
          elements: {             
            indicatorTotalAmountReceiptsToday: true,
            indicatorTotalReceiptsToday: true,
            barReceiptsMonths: true,
            listBalancePositiveCurrentAccount: true,
            listBalanceNegativeCurrentAccount: true,            
          }
        },
        parameters: {
          allowReceiptsTrashed: Helper.hasParametersAccess(Param.P40),
        },        
        primaryColor: '',
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      /* Configurar permisos de los widgets */      
      this.configWidget.elements.indicatorTotalAmountReceiptsToday = Helper.hasAccessWidget(this.configWidget, 'indicator_total_amount_receipts_today')
      this.configWidget.elements.indicatorTotalReceiptsToday = Helper.hasAccessWidget(this.configWidget, 'indicator_total_receipts_today')
      this.configWidget.elements.barReceiptsMonths = Helper.hasAccessWidget(this.configWidget, 'bar_receipts_months')
      this.configWidget.elements.listBalancePositiveCurrentAccount = Helper.hasAccessWidget(this.configWidget, 'list_balance_positive_current_account')
      this.configWidget.elements.listBalanceNegativeCurrentAccount = Helper.hasAccessWidget(this.configWidget, 'list_balance_negative_current_account')      
      /* Fin configuracion */
    },
    mounted() {
      this.setup()
    }, 
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      openReceipts() {
        this.$router.push({ name: 'ReceiptsErpStaffReceipts' })
      }, 
      openReceiptsTrashed() {
        this.$router.push({ name: 'ReceiptsErpStaffReceiptsTrashed' })
      }
    }
  }
</script>

<style>

</style>